<template>
  <div>
    <v-menu
      ref="menu"
      open-on-click
      offset-y
      left
      nudge-bottom="4"
      v-if="!hasError"
      :max-width="$vuetify.breakpoint.mobile ? 380 : 700"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-chip
          v-bind="attrs"
          v-on="on"
          :color="hasActiveNotifications ? 'primary' : 'transparent'"
          @click="getActiveNotifications"
        >
          <v-icon class="mr-3 ml-1" size="20">{{ hasActiveNotifications ? 'mdi-bell-alert' : 'mdi-bell-check' }}</v-icon>
          <v-avatar
            left
            class="primary darken-2"
            v-if="hasActiveNotifications"
          >
            {{ notifications.numberOfActive }}
          </v-avatar>
          <span :class="{'font-weight-light': !hasActiveNotifications}">{{ transc('notifications.numberOfActive', notifications.numberOfActive) }}</span>
        </v-chip>
      </template>
      <v-card>
        <v-card-text>
          <notifications-list
            :active-notifications="notifications.activeNotifications"
          />
        </v-card-text>
      </v-card>
    </v-menu>
    <div v-else>
      <v-icon small class="mr-2" color="warning lighten-3">mdi-alert</v-icon>
      <span class="caption font-weight-regular">{{ trans('notifications.errorLoading') }}</span>
    </div>
  </div>
</template>

<script>
import {LocaleUtils} from '@/utils/locale-utils';
import NotificationsList from '@/components/notifications/NotificationsList';
import {NotificationUtils} from '@/utils/notification-utils';

export default {
  name: 'NotificationsMenu',
  components: {
    NotificationsList
  },
  mixins: [
    LocaleUtils,
    NotificationUtils
  ],
  data () {
    return {
      hasError: false,
      activeNotificationsInterval: null,
      activeNotificationsIntervalSeconds: 5 * 60 * 1000
    }
  },
  mounted () {
    if (document.hasFocus()) {
      this.startActiveNotificationsInterval();
    }
    window.addEventListener('focus', this.startActiveNotificationsInterval);
    window.addEventListener('blur', this.clearActiveNotificationsInterval);
  },
  beforeDestroy () {
    this.clearActiveNotificationsInterval();
    window.removeEventListener('focus', this.startActiveNotificationsInterval);
    window.removeEventListener('blur', this.clearActiveNotificationsInterval);
  },
  methods: {
    getActiveNotificationsInternal () {
      const timestamp = new Date().valueOf();
      if (!this.notifications?.lastPolledAt || timestamp - this.notifications?.lastPolledAt > this.activeNotificationsIntervalSeconds) {
        this.getActiveNotifications()
          .then(response => {
            this.hasError = false;
            if (this.$refs.menu) {
              try {
                this.$nextTick(() => this.$refs.menu.updateDimensions());
              } catch (e) {
                console.warn('Could not update v-menu dimensions', e);
              }
            }
          })
          .catch(response => {
            this.hasError = true;
          })
      }
    },

    startActiveNotificationsInterval () {
      if (this.activeNotificationsInterval) {
        clearInterval(this.activeNotificationsInterval);
      }
      this.activeNotificationsInterval = setInterval(this.getActiveNotificationsInternal, 1000);
    },


    clearActiveNotificationsInterval () {
      if (this.activeNotificationsInterval) {
        clearInterval(this.activeNotificationsInterval);
      }
    }
  }
}
</script>

<style scoped>

</style>
